// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  dev: true,
  qa: false,
  uat: false,
  // blobKey : "?sv=2018-03-28&ss=b&srt=sco&sp=racwdl&st=2021-04-20T06%3A59%3A57Z&se=2171-04-20T07%3A04%3A58Z&spr=https%2Chttp&sig=3TBFQu369yom4bQ8%2FqEjxIqGiqjGwAO%2Bb2V5hfAevt8%3D",
  blobKey: "?si=ACITDEVKAR202601&spr=https&sv=2024-11-04&sr=c&sig=bGy4UTQ26JDA%2Fa8mzxSSEPm97Q4pO%2B9qEtmylAOzVUk%3D",
  blobKey2: "?si=ACITDEVMAN01&sv=2022-11-02&sr=c&sig=KQ8yj8tSzXRcpVFHI1Lw8zFNQ4bGYgA7oJEfaphucnI%3D",
  sso:'http://52.172.236.38:3015',
  API_BASE_URL: 'https://moocgatewayportal.lntedutech.com/',
  PAYMENT:'https://devpayment.lntedutech.com',
  uap:'https://uap-dev.lntiggnite.com',
  unifiedReport_URL :'https://unifiedreport-dev.lntedutech.com/',
  lxp_url:'https://lmsdev.lntedutech.com/redirection',
  captachaSiteKey: '6LfX5B8lAAAAAKKxlB1rPvwyhljiUalqTJ5psG6S',
  userOrigin: 'MOOC',
  gaMeasureId: "G-WNMPYL5PVE",
  learnerUrl: "https://skill.lntedutech.com/",
  profileUrl: "https://microcertstg.blob.core.windows.net/",
  orderAPIURL: 'https://us-east-1.aws.data.mongodb-api.com/app/charts-microcert-prod-cijxr/endpoint/embedding',
  env: 'prod'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
